import ApperIcon from '@/components/ApperIcon';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { formatRelativeTime } from '@/utils/date';
import { useCanvases } from '@/components/canvas/CanvasProvider';

// Shows that what the learner typed is safe: saved, saving, or not saved with a way to try again.
export default function SaveIndicator({ className }) {
  const { save, flush } = useCanvases();
  let icon = 'CloudCheck';
  let label = 'All changes saved';
  let tone = 'text-success';
  if (save.state === 'saving') {
    icon = 'CloudUpload';
    label = 'Saving';
    tone = 'text-muted-foreground';
  } else if (save.state === 'dirty') {
    icon = 'Cloud';
    label = 'Saving in a moment';
    tone = 'text-muted-foreground';
  } else if (save.state === 'error') {
    icon = 'CloudOff';
    label = 'Not saved yet';
    tone = 'text-destructive';
  }
  return (
    <div className={cn('flex items-center gap-2 text-xs font-medium', tone, className)} role="status" aria-live="polite">
      <ApperIcon name={icon} size={16} className={save.state === 'saving' ? 'animate-pulse' : ''} />
      <span>{label}</span>
      {save.state === 'saved' && save.at && <span className="hidden font-normal text-muted-foreground sm:inline">{formatRelativeTime(save.at)}</span>}
      {save.state === 'error' && (
        <>
          <span className="hidden max-w-56 truncate font-normal sm:inline" title={save.error || ''}>
            {save.error}
          </span>
          <Button type="button" size="sm" variant="outline" onClick={() => flush()}>
            Try again
          </Button>
        </>
      )}
    </div>
  );
}
